import posthog from 'posthog-js';

export function usePostHog() {
  posthog.init('phc_gzq5pqsKW2I7FGgcwrFp5mWmGTDb47bko00NYGl2UYD', {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    enable_recording_console_log: true,
  });

  return { posthog };
}
